import ClearIcon from '@mui/icons-material/Clear'
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import CloseDialogButton from '../../Shared/Dialogs/CloseDialogButton'

const Filter = ({
  title,
  id,
  content = <></>,
  count = null,
  hidden = false,
  onDelete = () => { },
  onClose = () => { },
  selected = false
}) => {
  const [open, setOpen] = useState(false)

  const handleOnClick = () => {
    setOpen(true)
  }

  const handleOnClose = () => {
    setOpen(false)
    onClose() //
  }

  return (
    <>
      {!hidden && (
        <>
          <Dialog
            open={open}
            onClose={handleOnClose}
            scroll="body"
            aria-labelledby="filters-dialog-title"
            aria-describedby="filters-dialog-content"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle
              variant="h4"
              display="flex"
              justifyContent="center"
            >
              {title}
            </DialogTitle>

            <CloseDialogButton onClose={handleOnClose} />

            {count && (
              <DialogTitle
                id="filters-dialog-title"
                display="flex"
                justifyContent="center"
              >
                <Box>
                  <Typography
                    variant="h6"
                    align="center"
                  >
                    {count}
                  </Typography>
                </Box>
              </DialogTitle>
            )}
            <DialogContent id="filters-dialog-content">{content}</DialogContent>
            <DialogActions></DialogActions>
          </Dialog>

          <Stack direction="row" spacing={-0.65} alignItems="center"
            sx={{
              bgcolor: selected
                ? 'primary.main'
                : 'rgba(98, 97, 97, 0.18)',
              borderRadius: '18px',
              paddingRight: '6px',
              '&:hover': {
                backgroundColor: selected
                  ? 'primary.dark'
                  : 'rgba(98, 97, 97, 0.45)'
              }
            }}
          >
            <Chip
              id={id}
              color={selected ? 'primary' : 'notSelected'}
              label={title}
              variant="text"
              size="medium"
              onClick={handleOnClick}
              sx={{
                backgroundColor: 'transparent',
                '&:hover': { backgroundColor: 'transparent' }
              }}
            />
            <IconButton
              aria-label={t('filters.removeFilters', { title })}
              size="small"
              onClick={onDelete}
              sx={{
                p: 0,
                width: 20,
                height: 20,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&.Mui-focusVisible': {
                  boxShadow: (theme) =>
                    selected
                      ? `0 0 0 2px ${theme.palette.common.white}`
                      : '0 0 0 2px rgba(0, 0, 0, 0.63)'
                },
                '&:hover': {
                  boxShadow:
                    selected
                      ? '0 0 0 2px rgba(255, 255, 255, 0.63)'
                      : '0 0 0 2px rgba(0, 0, 0, 0.63)'
                }
              }}
            >
              <ClearIcon
                fontSize="small"
                sx={{
                  width: 18,
                  height: 18,
                  fontSize: 13,
                  fontWeight: 'bold',
                  color:
                    selected
                      ? '#373232ba'
                      : '#f8f7f7',
                  background:
                    selected
                      ? '#f8f7f7a9'
                      : '#373232e2',
                  borderRadius: '50%'
                }}
              />
            </IconButton>
          </Stack>

        </>
      )
      }
    </>
  )
}

export default Filter